
import React from 'react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import { useIsMobile } from '@/hooks/use-mobile';

const PanelHeader = () => {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  return (
    <div className={`flex ${isMobile ? 'flex-col space-y-4' : 'justify-between'} items-center mb-6 md:mb-8`}>
      <h1 className="text-2xl md:text-3xl font-bold">{t('creator.dashboard')}</h1>
      <Button onClick={() => navigate("/create-derivative")} className="w-full md:w-auto gap-2">
        {t('sidebar.publishCreation')}
      </Button>
    </div>
  );
};

export default PanelHeader;
